import { BUILD_VERSION } from './buildVersion';

// prd images are built from a release tag (vX.Y.Z); dev images from a commit
// SHA (and local dev uses the 'dev' placeholder). So a tag-shaped build version
// means we're running the prd deployment — independent of the access URL.
export const IS_PROD = /^v\d/.test(BUILD_VERSION);

/** Short environment label shown in the UI (e.g. the sidebar). */
export const ENV_LABEL = IS_PROD ? 'prd' : 'dev';
